export default __webpack_public_path__ + "static/media/one-mvp-avatar.52f00c47.png";